import React, { memo, useMemo, useCallback } from "react"

import { useApp } from "../../../hooks/useApp"
import { useCheckout } from "../../../hooks/useCheckout"

export const withCartWidget = Component =>
  memo(({ name = "CartTotal" }: any) => {
    const { setCartHeight, globalStateReducer } = useApp()
    const { count } = useCheckout()

    const [{ activeCart }, dispatch] = globalStateReducer

    const handleActiveCart = useCallback(() => {
      dispatch({
        type: "setActiveCart",
        payload: !activeCart,
      })
      // const cartSection = document.getElementById("CheckoutSection").clientHeight
      // // const innerH = document.getElementById("MiniCartInner").clientHeight
      // const innerPadding = parseInt(window.getComputedStyle(document.getElementById("MiniCartInner"), null).paddingTop)
      // // const cartItemH = innerH - cartSection - innerPadding
      // const windowH = window.innerHeight
      // const cartItemH = windowH - cartSection - innerPadding
      // setCartHeight(cartItemH)
    }, [activeCart, dispatch])

    Component.displayName = name
    return useMemo(
      () => <Component count={count} activeCart={activeCart} handleActiveCart={handleActiveCart} />,
      [activeCart, count, handleActiveCart]
    )
  })
